<template>
    <div class="SharedTip-information">
        <div class="SharedTip-content">
            <div class="SharedTip-title">为向您提供产品或服务浏览、完成交易等功能，您的个人信息可能与以下第三方进行共享，我们将根据法律法规要求并参照行业最佳实践，不断完善和提升对您个人信息的安全保障水平。我们将严格遵守隐私政策的约定。具体共享情况说明如下：</div>

            <div class="SharedTip-table">
                <vxe-table border :data="tableData">
                    <vxe-table-column field="type" title="功能类型"></vxe-table-column>
                    <vxe-table-column field="thirdParty" title="所涉第三方"></vxe-table-column>
                    <vxe-table-column field="information" title="个人信息"></vxe-table-column>
                    <vxe-table-column field="Purpose" title="使用目的"></vxe-table-column>
                </vxe-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [
                    {
                        type: "提供平台服务",
                        thirdParty: "合作平台咨询顾问",
                        information: "交易基础信息、手机号、实名认证信息",
                        Purpose: "为您提供产品服务及产品交易后服务",
                    },
                    {
                        type: "产品交易服务",
                        thirdParty: "平台合作的第三方持牌机构",
                        information: "交易基础信息、实名认证信息",
                        Purpose: "确认交易完成并提供后续服务",
                    },
                    {
                        type: "安全保障服务",
                        thirdParty: "安全保障合作方",
                        information: "设备信息、日志信息、异常操作行为",
                        Purpose: "安全风险",
                    },
                ],
            };
        },

        created() {},

        methods: {},
    };
</script>
<style lang="less" scoped>
    .SharedTip-information {
        padding: 5px;
        width: 100%;
        box-sizing: border-box;
        .SharedTip-content {
            .SharedTip-title {
                font-size: 16px;
                color: #333;
                line-height: 1.5;
                padding-bottom: 10px;
            }
            .SharedTip-table {
                width: 100%;
                padding: 5px;
                box-sizing: border-box;
            }
        }
    }
</style>
